import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

import * as modal from '../../reducers/modalReducer';
import {BODY_TEXT_COLOR} from '../../config/colors';
// import SvgIcon from 'material-ui/SvgIcon';
import List from '../List';
import ListItemNew from '../ListItemNew';
import * as menu from '../../reducers/menuReducer';
import {changeUserType} from '../../actions/api';

import {
  HeaderDiv,
  HeaderTitleDiv,
  HeaderIconImg,
} from '../../pages';
import * as addressReducer from '../../reducers/addressReducer';
import { getConfigValue } from '../../reducers/configReducer';
import {
  addressesUri,
  updateDocsPageUri
} from '../../config/uri';
import {CUSTOMER_TYPE_ALLOW} from '../../config/const';
import CustomerType from '../../const/customer_type';

import './style.css';
import {isKioskMode as isKioskSelector} from '../../selectors/viewSelectors';
import {
  isEmailValidationEnabled,
  rewardsEnabledConfigSelector,
} from '../../selectors/configSelectors';
import {isDelivery} from '../../selectors/configSelectors';
import { pushWithQueryParams } from '../../services/uri';
import { openEmailUpdateForm } from '../../actions/modal';
import { getRewardsDollars } from '../../reducers/userReducer';

const styles = {
  headerIcon: {width: '30px', height: '30px'},
  highlightText: {
    fontWeight: 600
  }
};

const myAccountIcon = `${process.env.PUBLIC_URL}/assets/img/icons/preferences-disabled.png`;
class MyAccount extends Component {

  handleAddressesClick = () => {
    this.props.go(addressesUri);
  }

  handleDocsClick = () => {
    this.props.go(updateDocsPageUri);
  }

  handleChangePwdClick = () => {
    this.props.openChangePwdForm();
  }

  handleRadioBtnClick = (value) => {
    this.props.changeUserType(value);
  }

  renderAccountTypes = () => {
    const preselected = this.props.user.customerType;
    const { customerTypeAllowed } = this.props;

    if (customerTypeAllowed !== CustomerType.ALL) {
      return null;
    }

    return (
      <div className="account-item" style={{margin: '5px 0 0 20px', paddingBottom: '16px'}}>
        Change account type
        <RadioButtonGroup
          name="custmerType"
          valueSelected={preselected}
          onChange={(e, value) => {this.handleRadioBtnClick(value)}}>
          <RadioButton
            iconStyle={{fill: `#${this.props.secondaryColor}`}}
            key="MEDICAL"
            value="MEDICAL"
            label="Medical use"
            labelStyle={{fontSize: '15px', color: BODY_TEXT_COLOR, fontWeight: '400'}}
            id="MEDICAL"
          />
          <RadioButton
            iconStyle={{fill: `#${this.props.secondaryColor}`}}
            key="ADULT"
            value="ADULT"
            label="Adult use"
            labelStyle={{fontSize: '15px', color: BODY_TEXT_COLOR, fontWeight: '400'}}
            id="ADULT"
          />
        </RadioButtonGroup>
      </div>
    );
  }

  render() {
    const {
      isDelivery,
      isKiosk,
      isEmailValidationEnabled,
      rewardsDollars
    } = this.props;


    return (
      <div>
        <HeaderDiv>
            <HeaderIconImg style={styles.headerIcon} src={myAccountIcon} />
            <HeaderTitleDiv>ACCOUNT</HeaderTitleDiv>
        </HeaderDiv>
        <div className="account-options">
        {
            this.props.rewardsEnabled &&
            <List>
                <ListItemNew titles={["Earned Rewards" ]}>
                    <div style={{margin:'20px 0 20px 40px'}}>
                        <div><span style={styles.highlightText}>{rewardsDollars}</span> Earned Rewards</div>
                        {/*<div><span style={styles.highlightText}>{redeemedPoints}</span> Redeemed points</div>*/}
                    </div>
                </ListItemNew>
            </List>
        }

          {!isKiosk && isDelivery &&
          <div onClick={this.handleAddressesClick} className="account-item"><p>Addresses</p></div>}

          {!isKiosk &&
            <div onClick={this.handleDocsClick} className="account-item"><p>Documents</p></div>
          }

          <div onClick={this.handleChangePwdClick} className="account-item"><p>Change Password</p></div>
          {isEmailValidationEnabled && <div onClick={this.props.openEmailUpdate} className="account-item"><p>Update Email</p></div>}
          {this.renderAccountTypes()}
        </div>
      </div>
    );
  }
}

MyAccount.propTypes = {
  isKiosk: PropTypes.bool.isRequired,
  rewardsEnabled: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    rewardsEnabled: rewardsEnabledConfigSelector(state),
    rewardsDollars: getRewardsDollars(state),
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    user: state.user,
    customerTypeAllowed: getConfigValue(CUSTOMER_TYPE_ALLOW, state),
    isDelivery: isDelivery(state),
    isKiosk: isKioskSelector(state),
    isEmailValidationEnabled: isEmailValidationEnabled(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    go: uri => dispatch(pushWithQueryParams(uri)),
    hideModal: () => dispatch(modal.hideModal()),
    hideMenu: () => dispatch(menu.menuOff()),
    openChangePwdForm: () => dispatch(modal.openModal({
      modalType: 'CHANGE_PASSWORD_FORM',
      modalProps: {},
    })),
    openEmailUpdate: () => dispatch(openEmailUpdateForm({})),
    changeUserType: type => dispatch(changeUserType(type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyAccount.jsx